import { Close } from "@mui/icons-material"
import { Box, Chip, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material"
import MaterialTypography from "../../../components/MaterialTypography"
import { useLoading } from "../../../context/loading";
import { getUserDetailsByPolicyId } from "./Queries";
import axios from "axios";
import BASEURL from "../../Utils/Baseurl";
import Swal from "sweetalert2";
import { useEffect, useState } from "react";

const PolicyUserStatus = ({open, setOpen, selectedPolicyId, selectedPolicyTitle}) => {

    const { setCirleLoading } = useLoading();
    const [userPolicyDetails, setUserPolicyDetails] = useState([]);
    
    useEffect(() => {
        if(!open) return;
        fetchUserDetailsByPolicyId();
    },[open]);

    const fetchUserDetailsByPolicyId = async () => {
        if (!selectedPolicyId) return;

        setCirleLoading(true);

        try {
            const response = await axios.post(
            BASEURL,
            {
                query: getUserDetailsByPolicyId,
                variables: {
                policyId: Number(selectedPolicyId),
                },
            },
            {
                headers: {
                "Content-Type": "application/json",
                },
            }
            );

            const userStatusData = response?.data?.data?.policywiseUserStatus || [];

            const formattedUsers = userStatusData.map((item) => ({
                userName: `${item?.user?.firstName || ""} ${item?.user?.lastName || ""}`.trim(),
                policyTitle: item?.policy?.title || "",
                status: item?.status || "",
                statusAt: item?.statusAt || null,
            }));

            setUserPolicyDetails(formattedUsers);
            
            if (!userStatusData) {
            Swal.fire({
                icon: "info",
                title: "No user data found",
                timer: 1500,
                showConfirmButton: false,
            });
            return;
            }

        } catch (error) {
            console.error("Error Fetching Policy User Details:", error);

            Swal.fire({
                position: "center",
                icon: "error",
                title: "Failed to load user policy details",
                showConfirmButton: false,
                timer: 2000,
            });
        } finally {
            setCirleLoading(false);
        }
    };
  return (
    <Dialog open={open}>
        <DialogTitle>
            Employee Acknowledgement Status
            <IconButton
                aria-label="close"
                onClick={() => setOpen(false)}
                sx={{
                    position: "absolute",
                    right: 8,
                    top: 8
                }}
                >
                <Close />
            </IconButton>
        </DialogTitle>
        <DialogContent>
            <MaterialTypography variant="h6" fontWeight="medium" color="black">
                <b>Policy:</b> {selectedPolicyTitle ? selectedPolicyTitle : "Not Found"}
            </MaterialTypography>
            <Box mt={2} sx={{minWidth: 500}}>                
                <TableContainer
                    component={Paper}
                    sx={{
                        maxHeight: 350,
                        borderRadius: "12px",
                        boxShadow: "none",
                        border: "1px solid #e0e6ed"
                    }}
                >
                    <Table stickyHeader size="small">

                    {/* HEADER */}
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ fontWeight: 600 }}>
                                Employee Name
                            </TableCell>

                            <TableCell align="center" sx={{ fontWeight: 600 }}>
                                Status
                            </TableCell>
                        </TableRow>
                         {/* BODY */}
                        <TableBody>
                            {userPolicyDetails.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={2} align="center">
                                    No employees found
                                    </TableCell>
                                </TableRow>
                            ) : (
                            userPolicyDetails.map((emp, index) => (
                                <TableRow key={index} hover>

                                {/* Name */}
                                <TableCell>
                                    {emp.userName || "Unknown"}
                                </TableCell>

                                {/* Status */}
                                <TableCell align="center">
                                    <Chip
                                    label={emp.status || "Pending"}
                                    size="small"
                                    sx={{
                                        fontWeight: 600,
                                        minWidth: 100,

                                        backgroundColor:
                                        emp.status === "Acknowledged" ? "#e8f5e9"
                                            : emp.status === "Pending" ? "#fff8e1"         
                                            : "#f8c8c3",         

                                        color:
                                        emp.status === "Acknowledged" ? "#2e7d32"
                                            : emp.status === "Pending" ? "#f9a825"
                                            : "#d32f2f",
                                    }}
                                    />
                                </TableCell>
                                </TableRow>
                            ))
                            )}
                        </TableBody>
                    </TableHead>
                
                    </Table>
                </TableContainer>
            </Box>
        </DialogContent>
        <DialogActions>

        </DialogActions>
    </Dialog>
  )
}

export default PolicyUserStatus